/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Err_Otp_TitleInputs */

const es_ab_err_otp_title = /** @type {(inputs: Ab_Err_Otp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de verificación`)
};

const gl_ab_err_otp_title = /** @type {(inputs: Ab_Err_Otp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro de verificación`)
};

const en_ab_err_otp_title = /** @type {(inputs: Ab_Err_Otp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification error`)
};

/**
* | output |
* | --- |
* | "Verification error" |
*
* @param {Ab_Err_Otp_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_err_otp_title = /** @type {((inputs?: Ab_Err_Otp_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Err_Otp_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_err_otp_title(inputs)
	if (locale === "en") return en_ab_err_otp_title(inputs)
	return es_ab_err_otp_title(inputs)
});